module.exports = __webpack_public_path__ + "static/media/logo.e8059bf5.png";